export default "__VITE_ASSET__CWAkzcAN__"